(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbrman-revolver"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dbr-revolver')) {
    customElements.define('dbr-revolver', class extends HTMLElement {
      async connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        const connection = this.controller;
        await this.loadCollectionProducts(this.signal);
        if (!this.isConnected || connection !== this.controller) return;
        this.wheel = this.querySelector('[data-wheel]');
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.originals = [...this.querySelectorAll('[data-item]')];
        this.originals.forEach((item, index) => { item.dataset.index = index; });
        this.count = this.originals.length;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.playing = this.dataset.autoplay === 'true' && !this.reduced.matches && this.count > 1;
        this.autoplayIntent = this.playing;
        this.resumeWanted = false;
        this.resumeTimer = null;
        this.stepElapsed = 0;
        this.customAudioFailed = false;
        this.effectBuffer = null;
        this.effectLoading = false;
        this.pendingAudio = false;
        this.nativeAudio = this.dataset.audioUrl ? new Audio(this.dataset.audioUrl) : null;
        this.nativeAudioMode = false;
        this.nativeAudioPrimed = false;
        if (this.nativeAudio) this.nativeAudio.preload = 'none';
        this.sound = this.dataset.sound === 'true';
        this.position = 0;
        this.active = -1;
        this.target = null;
        this.velocity = 0;
        this.visible = false;
        this.focused = false;
        this.drag = null;
        this.lastTime = 0;
        this.raf = 0;
        this.video = this.querySelector('video');
        this.items = this.originals;
        this.slots = this.count;
        this.step = this.slots ? 2 * Math.PI / this.slots : 1;
        this.on(this.wheel, 'click', e => {
          const item = e.target.closest('[data-item]');
          if (!item || performance.now() < (this.suppressClickUntil || 0)) return;
          this.unlockAudio();
          this.stop(false);
          this.goTo(this.items.indexOf(item));
        });
        this.on(this.querySelector('[data-prev]'), 'click', () => this.move(-1));
        this.on(this.querySelector('[data-next]'), 'click', () => this.move(1));
        this.on(this.querySelector('[data-play]'), 'click', () => {
          this.unlockAudio();
          const shouldPlay = !(this.playing || this.resumeWanted) && this.count > 1;
          this.stop();
          this.autoplayIntent = shouldPlay;
          this.playing = shouldPlay;
          this.target = null;
          this.velocity = 0;
          this.updateControls();
          this.wake();
        });
        this.on(this.querySelector('[data-sound-toggle]'), 'click', () => {
          this.sound = !this.sound;
          if (this.sound) this.unlockAudio();
          else { this.pendingAudio = false; this.stopVoice(); this.nativeAudio?.pause(); }
          this.updateControls();
        });
        this.on(this.wheel, 'pointerdown', e => this.pointerDown(e));
        this.on(this.wheel, 'pointermove', e => this.pointerMove(e));
        this.on(this.wheel, 'pointerup', e => this.pointerEnd(e));
        this.on(this.wheel, 'pointercancel', e => this.pointerEnd(e, true));
        this.on(this.wheel, 'lostpointercapture', e => this.pointerEnd(e, true));
        this.on(this.wheel, 'dragstart', e => e.preventDefault());
        this.on(this.querySelector('.dbr-revolver__feature'), 'dragstart', e => e.preventDefault());
        this.on(this, 'keydown', e => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          if (e.target.closest('input, textarea, select, [contenteditable="true"]')) return;
          e.preventDefault();
          const direction = e.key === 'ArrowRight' ? 1 : -1;
          this.highlightArrow(direction);
          this.move(direction);
        });
        this.on(this, 'focusin', e => { this.focused = e.target.matches(':focus-visible'); });
        this.on(this, 'focusout', e => {
          if (!this.contains(e.relatedTarget)) { this.focused = false; this.wake(); }
        });
        this.on(document, 'visibilitychange', () => { this.syncVideo(); this.wake(); });
        this.on(this.mobile, 'change', () => {
          this.measure();
          if (this.nativeAudio) this.nativeAudio.volume = this.soundVolume();
          if (this.voice && this.audio) {
            const now = this.audio.currentTime;
            this.voice.gain.gain.cancelScheduledValues(now);
            this.voice.gain.gain.setTargetAtTime(this.soundVolume() * this.voice.level, now, .005);
          }
        });
        this.on(this.reduced, 'change', () => {
          if (this.reduced.matches) this.stop();
          this.syncVideo();
        });
        this.on(document, 'shopify:block:select', e => {
          const index = this.originals.findIndex(item => item.dataset.blockId === e.detail.blockId);
          if (index >= 0) { this.stop(); this.goTo(index); }
        });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.wheel);
        this.resizeObserver.observe(this.querySelector('.dbr-revolver__feature'));
        const currentSignal = this.signal;
        document.fonts?.ready.then(() => { if (!currentSignal.aborted) this.measure(); });
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.syncVideo();
          this.wake();
        });
        this.intersectionObserver.observe(this);
        this.measure();
        this.setAttribute('data-ready', '');
        this.layoutControls();
        this.updateControls();
      }
      on(target, type, fn) { if (target) target.addEventListener(type, fn, { signal: this.signal }); }
      mod(n, m) { return ((n % m) + m) % m; }
      measure() {
        const css = getComputedStyle(this.wheel);
        this.itemHeight = parseFloat(css.getPropertyValue('--rv-active-item')) || 180;
        const requestedRadius = parseFloat(css.getPropertyValue('--rv-active-radius')) || 300;
        this.radius = Math.max(requestedRadius, this.wheel.clientHeight - this.itemHeight * .75 - 12);
        this.centerX = this.wheel.clientWidth / 2;
        this.centerY = this.radius + this.itemHeight + 12;
        this.rebuildWheel();
        this.measureFeatureLayout();
        this.render();
        this.layoutControls();
      }
      layoutControls() {
        const toolbar = this.querySelector('.dbr-revolver__toolbar');
        const nav = this.querySelector('.dbr-revolver__navigation');
        const playGroup = this.querySelector('.dbr-revolver__play-control');
        const soundGroup = this.querySelector('.dbr-revolver__sound-control');
        const key = this.mobile.matches ? 'mobilePosition' : 'position';
        const featured = nav.dataset[key] === 'featured';
        nav.toggleAttribute('data-feature-arrows', featured);

        // Restore groups before measuring visibility or creating new shared groups.
        this.querySelectorAll('.dbr-revolver__shared-controls').forEach(wrapper => {
          toolbar.append(...wrapper.children);
          wrapper.remove();
        });
        this.sharedControls = null;
        const groups = [nav, playGroup, soundGroup].filter(Boolean);
        groups.forEach(group => {
          group.hidden = false;
          group.hidden = ![...group.children].some(el => getComputedStyle(el).display !== 'none');
        });

        // Combine controls in the same corner so buttons never sit on top of each other.
        const positionGroups = new Map();
        groups.forEach(group => {
          if (group.hidden || (group === nav && featured)) return;
          const position = group.dataset[key];
          if (!positionGroups.has(position)) positionGroups.set(position, []);
          positionGroups.get(position).push(group);
        });
        positionGroups.forEach((members, position) => {
          if (members.length < 2) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'dbr-revolver__shared-controls';
          wrapper.dataset.position = position;
          wrapper.dataset.mobilePosition = position;
          wrapper.dataset.toggleLayout = toolbar.dataset.toggleLayout;
          wrapper.dataset.mobileToggleLayout = toolbar.dataset.mobileToggleLayout;
          const styles = members.map(member => getComputedStyle(member));
          for (const axis of ['x', 'y']) {
            wrapper.style.setProperty('--rv-edge-' + axis, Math.max(...styles.map(style => parseFloat(style.getPropertyValue('--rv-edge-' + axis)) || 0)) + 'px');
          }
          wrapper.style.setProperty('--rv-shared-gap', Math.max(...styles.map(style => parseFloat(style.gap) || 0)) + 'px');
          toolbar.append(wrapper);
          wrapper.append(...members);
        });
        this.positionFeaturedArrows();
      }
      positionFeaturedArrows() {
        const nav = this.querySelector('.dbr-revolver__navigation');
        if (!nav || !nav.hasAttribute('data-feature-arrows')) return;
        const feature = this.querySelector('.dbr-revolver__feature');
        const box = feature.getBoundingClientRect();
        if (!box.width || !box.height) return;
        const stage = this.getBoundingClientRect();
        const css = getComputedStyle(nav);
        const size = parseFloat(css.getPropertyValue('--rv-size')) || 44;
        const gap = parseFloat(css.getPropertyValue('--rv-image-gap')) || 0;
        const edge = parseFloat(css.getPropertyValue('--rv-image-edge')) || 0;
        const heroHeight = Math.max(0, box.height - (this.detailsHeight || 0) - 12);
        const ratio = Math.max(0, ...this.panels.map(panel => Number(panel.dataset.imageRatio) || 1));
        const width = Math.min(box.width, heroHeight * ratio);
        const center = box.left - stage.left - this.clientLeft + box.width / 2;
        const halfWidth = Math.min(width / 2 + gap + size, Math.max(0, this.clientWidth / 2 - edge));
        const left = center - halfWidth;
        nav.style.setProperty('--rv-feature-arrow-left', left + 'px');
        nav.style.setProperty('--rv-feature-arrow-width', halfWidth * 2 + 'px');
        nav.style.setProperty('--rv-feature-arrow-y', box.top - stage.top - this.clientTop + heroHeight / 2 + 'px');
      }
      measureFeatureLayout() {
        const feature = this.querySelector('.dbr-revolver__feature');
        if (!feature.clientWidth) return;
        const measure = document.createElement('div');
        measure.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:100%;top:0;left:0;';
        measure.setAttribute('aria-hidden', 'true');
        measure.inert = true;
        this.panels.forEach(panel => {
          const details = panel.querySelector('.dbr-revolver__details').cloneNode(true);
          details.style.minHeight = '0';
          measure.append(details);
        });
        feature.append(measure);
        this.detailsHeight = Math.ceil(Math.max(0, ...[...measure.children].map(el => el.getBoundingClientRect().height)));
        measure.remove();
        this.style.setProperty('--rv-details-height', this.detailsHeight + 'px');
      }
      highlightArrow(direction) {
        clearTimeout(this.keyTimer);
        this.querySelectorAll('[data-key-active]').forEach(button => button.removeAttribute('data-key-active'));
        const button = this.querySelector(direction < 0 ? '[data-prev]' : '[data-next]');
        if (!button || button.disabled || !button.getClientRects().length) return;
        if (document.activeElement?.matches('[data-prev], [data-next]') && this.contains(document.activeElement)) button.focus({ preventScroll: true });
        button.setAttribute('data-key-active', '');
        this.keyTimer = setTimeout(() => button.removeAttribute('data-key-active'), 180);
      }
      preloadAdjacentImages() {
        if (!this.count) return;
        for (const offset of [-1, 1]) {
          const image = this.panels[this.mod(this.active + offset, this.count)]?.querySelector('.dbr-revolver__hero img');
          if (image) image.loading = 'eager';
        }
      }
      rebuildWheel() {
        if (!this.count) return;
        const density = (Number(this.dataset.density) || 100) / 100;
        const desired = Math.max(3, Math.ceil(2 * Math.PI * (this.radius + this.itemHeight * .5) / (this.itemHeight * .55) * density));
        const slots = Math.ceil(desired / this.count) * this.count;
        if (slots === this.slots) return;
        this.querySelectorAll('[data-clone]').forEach(item => item.remove());
        for (let i = this.count; i < slots; i++) {
          const clone = this.originals[i % this.count].cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          clone.dataset.clone = 'true';
          this.wheel.append(clone);
        }
        this.items = [...this.wheel.querySelectorAll('[data-item]')];
        this.slots = slots;
        this.step = 2 * Math.PI / slots;
        this.active = -1;
      }
      render() {
        if (!this.count) return;
        this.items.forEach((item, i) => {
          const angle = (i + this.position) * this.step;
          const x = this.centerX + Math.sin(angle) * this.radius;
          const y = this.centerY - Math.cos(angle) * this.radius;
          item.style.transform = `translate(${x}px, ${y}px) translate(-50%, -100%) rotate(${angle}rad)`;
          const shown = Math.cos(angle) > 0 && x > -this.itemHeight && x < this.wheel.clientWidth + this.itemHeight;
          item.style.visibility = shown ? 'visible' : 'hidden';
          item.tabIndex = shown ? 0 : -1;
          item.setAttribute('aria-hidden', String(!shown));
        });
        const active = this.mod(-Math.round(this.position), this.count);
        if (active === this.active) return;
        const previous = this.active;
        this.active = active;
        this.panels.forEach((panel, i) => { panel.hidden = i !== active; });
        this.preloadAdjacentImages();
        this.items.forEach(item => item.setAttribute('aria-pressed', String(Number(item.dataset.index) === active)));
        const counter = this.querySelector('[data-counter]');
        if (counter) counter.textContent = `${active + 1} / ${this.count}`;
        if (!this.playing) this.querySelector('[data-status]').textContent = this.originals[active].getAttribute('aria-label');
        if (previous !== -1) this.tick();
      }
      updateControls() {
        const play = this.querySelector('[data-play]');
        play.setAttribute('aria-pressed', String(this.playing));
        const showPause = this.playing || this.resumeWanted;
        play.querySelector('[data-play-icon]').hidden = showPause;
        play.querySelector('[data-pause-icon]').hidden = !showPause;
        [play, this.querySelector('[data-prev]'), this.querySelector('[data-next]')].forEach(button => { button.disabled = this.count < 2; });
        this.querySelector('[data-sound-toggle]')?.setAttribute('aria-pressed', String(this.sound));
      }
      stop(permanent = true) {
        this.stepElapsed = 0;
        clearTimeout(this.resumeTimer);
        this.resumeTimer = null;
        if (permanent) this.autoplayIntent = false;
        this.resumeWanted = !permanent && this.autoplayIntent && this.dataset.resume === 'true' && !this.reduced.matches;
        this.playing = false;
        this.velocity = 0;
        this.updateControls();
      }
      queueResume() {
        if (!this.resumeWanted || this.resumeTimer || this.drag || this.target !== null || Math.abs(this.velocity) > .04) return;
        const delay = Math.max(.1, Math.min(10, Number(this.dataset.resumeDelay) || 1));
        this.resumeTimer = setTimeout(() => {
          this.resumeTimer = null;
          if (!this.isConnected || !this.autoplayIntent || this.reduced.matches) return;
          this.resumeWanted = false;
          this.playing = this.count > 1;
          this.updateControls();
          this.wake();
        }, delay * 1000);
      }
      move(direction) {
        if (this.count < 2) return;
        this.unlockAudio();
        this.stop(false);
        this.target = Math.round(this.target ?? this.position) - direction;
        this.settle();
      }
      goTo(slot) {
        const currentSlot = -this.position;
        let delta = this.mod(slot - currentSlot + this.slots / 2, this.slots) - this.slots / 2;
        this.target = this.position - delta;
        this.settle();
      }
      settle() {
        if (this.reduced.matches) { this.position = this.target; this.target = null; this.render(); this.queueResume(); }
        else this.wake();
      }
            pointerDown(e) {
        if (this.count < 2 || !e.isPrimary || e.button !== 0) return;

        this.unlockAudio();
        this.stop(false);
        this.target = null;

        this.drag = {
          id: e.pointerId,
          x: e.clientX,
          y: e.clientY,
          lastX: e.clientX,
          lastTime: performance.now(),
          moved: false
        };

        this.wheel.setPointerCapture(e.pointerId);
      }
            pointerMove(e) {
        const drag = this.drag;
        if (!drag || drag.id !== e.pointerId) return;

        const dx = e.clientX - drag.x;

        if (!drag.moved) {
          if (Math.abs(dx) < 4) return;

          drag.moved = true;
          this.wheel.setAttribute('data-dragging', '');
        }

        const now = performance.now();
        const elapsed = Math.max(.016, (now - drag.lastTime) / 1000);

        const change =
          (e.clientX - drag.lastX) /
          Math.max(40, this.radius * this.step);

        this.position += change;

        this.velocity = Math.max(
          -8,
          Math.min(8, change / elapsed)
        );

        drag.lastX = e.clientX;
        drag.lastTime = now;

        this.render();
      }
      pointerEnd(e, cancelled = false) {
        const drag = this.drag;
        if (!drag || drag.id !== e.pointerId) return;
        this.drag = null;
        this.wheel.removeAttribute('data-dragging');
        if (this.wheel.hasPointerCapture(e.pointerId)) this.wheel.releasePointerCapture(e.pointerId);
        if (drag.moved) this.suppressClickUntil = performance.now() + 350;
        if (cancelled || this.reduced.matches || performance.now() - drag.lastTime > 100) this.velocity = 0;
        if (!this.velocity) this.target = Math.round(this.position);
        if (this.reduced.matches) this.settle();
        else this.wake();
      }
      wake() {
        if (this.raf || !this.visible || document.hidden || !this.isConnected) return;
        this.lastTime = 0;
        this.raf = requestAnimationFrame(t => this.frame(t));
      }
      frame(time) {
        this.raf = 0;
        if (!this.visible || document.hidden || !this.isConnected) return;
        const dt = this.lastTime ? Math.min(.05, (time - this.lastTime) / 1000) : 0;
        this.lastTime = time;
        let moving = false;
        if (!this.drag) {
          if (this.target !== null) {
            this.position += (this.target - this.position) * (1 - Math.exp(-12 * dt));
            if (Math.abs(this.target - this.position) < .001) { this.position = this.target; this.target = null; }
            else moving = true;
          } else if (Math.abs(this.velocity) > .04) {
            this.position += this.velocity * dt;
            this.velocity *= Math.exp(-5 * dt);
            if (Math.abs(this.velocity) <= .04) { this.velocity = 0; this.target = Math.round(this.position); }
            moving = true;
          } else if (this.playing && !this.focused) {
            const speed = Number(this.mobile.matches ? this.dataset.speedMobile : this.dataset.speed) || 5;
            const direction = this.dataset.direction === 'cw' ? 1 : -1;
            if (this.dataset.rotationMode === 'stepped') {
              this.stepElapsed += dt;
              if (this.stepElapsed >= Math.max(.1, speed - .6)) {
                this.stepElapsed = 0;
                this.target = Math.round(this.position) + direction;
              }
            } else {
              this.position += direction * dt / speed;
            }
            moving = true;
          }
        }
        if (this.target === null && Math.abs(this.position) > this.slots * 10) this.position %= this.slots;
        this.render();
        if (!moving && !this.drag) this.queueResume();
        if (moving || (this.playing && !this.focused && !this.drag)) this.raf = requestAnimationFrame(t => this.frame(t));
      }
      unlockAudio() {
        if (!this.sound) return;
        if (this.nativeAudio && !this.nativeAudioPrimed) {
          this.nativeAudioPrimed = true;
          const element = this.nativeAudio;
          element.muted = true;
          element.play().then(() => {
            if (!this.nativeAudioMode) { element.pause(); element.currentTime = 0; }
            element.muted = false;
          }).catch(() => { element.muted = false; });
        }
        try {
          const AudioContext = window.AudioContext || window.webkitAudioContext;
          if (!AudioContext) return;
          if (!this.audio) this.audio = new AudioContext();
          if (this.audio.state === 'suspended') this.audio.resume().catch(() => {});
          this.loadEffect();
        } catch (_) {}
      }
      soundVolume() {
        const value = Number(this.mobile.matches ? this.dataset.volumeMobile : this.dataset.volume);
        return Number.isFinite(value) ? Math.max(0, Math.min(1, value)) : 1;
      }
      loadEffect() {
        if (!this.dataset.audioUrl || this.effectBuffer || this.effectLoading || this.customAudioFailed) return;
        this.effectLoading = true;
        const context = this.audio;
        const signal = this.signal;
        fetch(this.dataset.audioUrl, { signal })
          .then(response => { if (!response.ok) throw new Error('Audio unavailable'); return response.arrayBuffer(); })
          .then(bytes => context.decodeAudioData(bytes))
          .then(buffer => {
            if (signal.aborted) return;
            this.effectBuffer = buffer;
            this.nativeAudio?.pause();
            this.effectLoading = false;
            if (this.pendingAudio) this.playEffect();
          })
          .catch(() => {
            if (signal.aborted) return;
            this.effectLoading = false;
            this.nativeAudioMode = true;
            this.customAudioFailed = true;
            if (this.pendingAudio) this.playEffect();
          });
      }
      stopVoice() {
        const voice = this.voice;
        if (!voice || !this.audio) return;
        this.voice = null;
        const now = this.audio.currentTime;
        voice.gain.gain.cancelScheduledValues(now);
        voice.gain.gain.setValueAtTime(voice.gain.gain.value, now);
        voice.gain.gain.linearRampToValueAtTime(0, now + .005);
        try { voice.source.stop(now + .006); } catch (_) {}
      }
      tick() {
        if (this.dataset.haptics === 'true' && !this.playing && !this.reduced.matches && navigator.vibrate) navigator.vibrate(8);
        this.playEffect();
      }
      playEffect() {
        this.pendingAudio = false;
        if (!this.sound || this.soundVolume() <= 0) return;
        if (this.nativeAudioMode && this.nativeAudio) {
          this.nativeAudio.muted = false;
          this.nativeAudio.volume = this.soundVolume();
          this.nativeAudio.currentTime = 0;
          this.nativeAudio.play().catch(error => {
            if (error.name === 'AbortError' || !this.isConnected) return;
            this.nativeAudioMode = false;
            this.playEffect();
          });
          return;
        }
        if (!this.audio || this.audio.state !== 'running') return;
        if (this.effectLoading) { this.pendingAudio = true; return; }
        this.stopVoice();
        const now = this.audio.currentTime;
        const gain = this.audio.createGain();
        const source = this.effectBuffer ? this.audio.createBufferSource() : this.audio.createOscillator();
        const level = this.effectBuffer ? 1 : .12;
        if (this.effectBuffer) source.buffer = this.effectBuffer;
        else {
          source.type = 'square';
          source.frequency.value = Number(this.dataset.pitch) || 400;
        }
        gain.gain.setValueAtTime(0, now);
        gain.gain.linearRampToValueAtTime(this.soundVolume() * level, now + .002);
        if (!this.effectBuffer) gain.gain.exponentialRampToValueAtTime(.0001, now + .04);
        source.connect(gain);
        gain.connect(this.audio.destination);
        const voice = { source, gain, level };
        this.voice = voice;
        source.start(now, 0);
        if (!this.effectBuffer) source.stop(now + .05);
        source.onended = () => {
          source.disconnect();
          gain.disconnect();
          if (this.voice === voice) this.voice = null;
        };
      }
      syncVideo() {
        if (!this.video) return;
        if (this.visible && !document.hidden && !this.reduced.matches) this.video.play().catch(() => {});
        else this.video.pause();
      }
      async loadCollectionProducts(signal) {
        const feature = this.querySelector('.dbr-revolver__feature');
        const wheel = this.querySelector('[data-wheel]');
        const seen = new Set();
        const load = async value => {
          const url = new URL(value, location.href);
          if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Invalid collection page');
          url.searchParams.set('section_id', this.dataset.sectionId);
          if (seen.has(url.href)) throw new Error('Repeated collection page');
          seen.add(url.href);
          const response = await fetch(url, {credentials:'same-origin',signal:AbortSignal.any([signal,AbortSignal.timeout(15000)])});
          if (!response.ok) throw new Error('Collection page unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = doc.getElementById(this.id);
          if (!root?.querySelector('.dbr-revolver__feature') || !root.querySelector('[data-wheel]')) throw new Error('Invalid collection section');
          return root;
        };
        this.setAttribute('aria-busy', 'true');
        try {
          if (Number(feature.dataset.revolverPage) > 1) {
            const first = new URL(location.href);
            first.searchParams.set(feature.dataset.revolverPageParam || 'page', '1');
            const root = await load(first);
            feature.replaceChildren(...root.querySelector('.dbr-revolver__feature').childNodes);
            wheel.replaceChildren(...root.querySelector('[data-wheel]').childNodes);
            feature.dataset.revolverNext = root.querySelector('.dbr-revolver__feature').dataset.revolverNext || '';
            feature.dataset.revolverPage = '1';
          }
          while (feature.dataset.revolverNext) {
            const root = await load(feature.dataset.revolverNext);
            const nextFeature = root.querySelector('.dbr-revolver__feature');
            const panels = [...nextFeature.querySelectorAll('[data-panel]')];
            const items = [...root.querySelectorAll('[data-wheel] > [data-item]')];
            if (!panels.length || panels.length !== items.length) throw new Error('Incomplete collection page');
            feature.append(...panels);
            wheel.append(...items);
            feature.dataset.revolverNext = nextFeature.dataset.revolverNext || '';
          }
        } catch {
          if (!signal.aborted) {
            const status = document.createElement('p');
            status.className = 'dbr-revolver__empty';
            status.setAttribute('role', 'status');
            status.textContent = this.dataset.collectionError;
            this.append(status);
          }
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.resumeTimer);
        this.stopVoice();
        this.pendingAudio = false;
        if (this.nativeAudio) { this.nativeAudio.pause(); this.nativeAudio.removeAttribute('src'); this.nativeAudio.load(); this.nativeAudio = null; }
        clearTimeout(this.keyTimer);
        cancelAnimationFrame(this.raf);
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.video?.pause();
        if (this.audio) { this.audio.close().catch(() => {}); this.audio = null; }
        this.querySelectorAll('[data-clone]').forEach(item => item.remove());
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gorilla-position"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sprplx-backstage-pass')) {
    customElements.define('sprplx-backstage-pass', class extends HTMLElement {
      connectedCallback() {
        if (this.copyHandler) return;
        this.copyHandler = async () => {
          const feedback = this.querySelector('[data-feedback]');
          try {
            await navigator.clipboard.writeText(this.querySelector('[data-code]').textContent.trim());
            this.querySelector('[data-button-label]').textContent = this.dataset.copied;
            feedback.textContent = this.dataset.success;
          } catch {
            feedback.textContent = this.dataset.error;
          }
        };
        this.querySelector('[data-copy]').addEventListener('click', this.copyHandler);
      }
      disconnectedCallback() {
        this.querySelector('[data-copy]')?.removeEventListener('click', this.copyHandler);
        this.copyHandler = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
